<template>
  <div class="flex flex-wrap gap-1" :class="$attrs.class">
    <label v-if="label" class="form-label mb-1">{{ label }}:</label>
    <button type="button" :id="id" role="switch" :aria-checked="state" @click="toggle" :class="[
      'relative inline-flex h-5 w-10 items-center rounded-full transition-colors focus:outline-none',
      state ? 'bg-green-600' : 'bg-gray-300 border-red-500 border'
    ]">
      <span :class="[
        'inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform',
        state ? 'translate-x-5' : 'translate-x-1 !bg-red-500'
      ]" />
    </button>
    <label class="inline-block ml-2">
      <span v-if="state">{{ labelChecked }}</span>
      <span v-else>{{ labelUnchecked }}</span>
    </label>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>

import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `switch-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    labelChecked: String,
    labelUnchecked: String,
    modelValue: Boolean,
  },
  emits: ['update:modelValue'],

  data() {
    return {
      state: this.$props.modelValue,
    }
  },

  watch: {
    modelValue(modelValue) {
      this.state = modelValue
    },

    state(state) {
      this.$emit('update:modelValue', state);
    }
  },
  methods: {
    toggle() {
      this.state = !this.state
      this.$emit('click')
    },
    focus() {
      // opcional: implementar se necessário
    },
    select() {
      // opcional: implementar se necessário
    },
  },
}
</script>
